import cx from 'classnames'

export function TableCell({
  children,
  className,
  colSpan,
  align
}: {
  children?: React.ReactNode
  className?: string
  colSpan?: number
  align?: 'left' | 'right' | 'center'
  borderless?: boolean
}) {
  return (
    <td className={cx('table-cell', className)} align={align} colSpan={colSpan}>
      {children}
    </td>
  )
}
